import { DayOrdersStatistics } from '@api/shipping-data/types/DayOrdersStatistics';
import { StatisticCardData, StatisticCardState } from 'components/statistic-card/StatisticCardData';
import { OrdersStatisticModel } from '@pages/orders/statistics/OrdersStatisticModel';
import { getDefaultNumber } from 'components/global/utils';



export const convertToOrdersStatisticModel = (summary: DayOrdersStatistics | null | undefined): OrdersStatisticModel | null => {
	if (!summary) return null;
	
	const totalOrders: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Celkem objednáno',
		tooltip: 'Počet obj na daný den (bez obj předatumovaných na jiný den).\u00a0HL jsou z 1 verze obj.',
		value: getDefaultNumber(summary.totalOrders),
		volume: getDefaultNumber(summary.totalOrdersItemsVolume),
	}
	const outgoingRedated: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Předatumované na další den',
		tooltip: 'Počet obj předatumovaných z daného dne na jiný den.\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalOutgoingRedatedOrders),
		volume: getDefaultNumber(summary.totalOutgoingRedatedOrdersVolume),
		percent: getDefaultNumber(summary.totalOutgoingRedatedOrdersPct),
	}
	const cancelledPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Zrušené před rozvozem',
		tooltip: 'Počet zrušených obj ve fázi plánování (SAP):\u00a0zrušil PPAS / celkem zrušeno (PPAS + CUST).\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalCancelledOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalCancelledOrdersPlanning),
		volume: getDefaultNumber(summary.totalCancelledOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalCancelledOrdersPlanningPct),
	}
	const reducedPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Pokrácené před rozvozem',
		tooltip: 'Počet pokrácených obj ve fázi plánování (SAP):\u00a0pokrátil PPAS / celkem pokráceno (PPAS + CUST).\u00a0HL z 1.verze obj.',
		value: getDefaultNumber(summary.totalReducedOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalReducedOrdersPlanning),
		volume: getDefaultNumber(summary.totalReducedOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalReducedOrdersPlanningPct),
	}
	const changedPlanning: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Všechny změny před rozvozem',
		tooltip: 'Předatumované na další den + zrušené před rozvozem + pokrácené před rozvozem.',
		value: getDefaultNumber(summary.totalChangedOrdersPpasPlanning),
		maxValue: getDefaultNumber(summary.totalChangedOrdersPlanning),
		volume: getDefaultNumber(summary.totalChangedOrdersVolumePlanning),
		percent: getDefaultNumber(summary.totalChangedOrdersPlanningPct),
	}
	const perfectlyDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Perfektně doručené',
		tooltip: 'Doručeno - Nedoručeno - Pokrácené při rozvozu/z Doručeno.',
		value: getDefaultNumber(summary.totalPerfectlyDeliveredDeliveries),
		maxValue: getDefaultNumber(summary.totalDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalPerfectlyDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalPerfectlyDeliveredOrdersPct),
		state:
			summary.totalPerfectlyDeliveredOrdersPct >= 96 ? StatisticCardState.success :
			summary.totalPerfectlyDeliveredOrdersPct >= 90 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}
	const notDelivered: StatisticCardData = {
		id: 'preview-statistic-card-',
		label: 'Nedoručeno',
		tooltip: 'Chyba PPAS / Celkem nedoručeno (chyba PPAS + CUST).',
		value: getDefaultNumber(summary.totalNotDeliveredDeliveriesDueToPpas),
		maxValue: getDefaultNumber(summary.totalNotDeliveredDeliveries),
		volume: getDefaultNumber(summary.totalNotDeliveredDeliveriesVolume),
		percent: getDefaultNumber(summary.totalNotDeliveredDeliveriesPct),
		state:
			summary.totalNotDeliveredDeliveriesPct < 5 ? StatisticCardState.success :
			summary.totalNotDeliveredDeliveriesPct <= 10 ? StatisticCardState.warning :
			StatisticCardState.danger,
	}

	const createdStatistics: OrdersStatisticModel = {
		totalOrders,
		outgoingRedated,
		cancelledPlanning,
		reducedPlanning,
		changedPlanning,
		perfectlyDelivered,
		notDelivered,
	}
	return createdStatistics;
}